import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDImage from 'components/cd-image-upload'
import CDButton from 'components/cd-button'
import Loader from 'components/loader'
import { settingsApi } from '../restaurant.api'

// The backend stores SEO under settings.seo; this page reads/writes that
// sub-object via the shared settings endpoint. ogImage is kept as a flat
// Formik field (cd-image-upload doesn't support nested paths) and wrapped
// back into the seo object on submit.
const toInitialValues = (seo) => ({
  metaTitle: seo?.metaTitle || '',
  metaDescription: seo?.metaDescription || '',
  keywords: seo?.keywords || '',
  ogImage: seo?.ogImage || '',
  sitemapEnabled: seo?.sitemapEnabled ?? true,
})

function Seo() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [seo, setSeo] = useState(null)

  useEffect(() => {
    ;(async () => {
      const { response } = await settingsApi.get()
      if (response) setSeo(response.data?.seo || {})
      setLoading(false)
    })()
  }, [])

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      seo: {
        metaTitle: values.metaTitle,
        metaDescription: values.metaDescription,
        keywords: values.keywords,
        ogImage: values.ogImage,
        sitemapEnabled: values.sitemapEnabled,
      },
    }
    const { response } = await settingsApi.update(payload)
    setSubmitting(false)
    if (response?.data) setSeo(response.data.seo || {})
  }

  if (loading) return <Loader />

  return (
    <div>
      <div className='tw-mb-4'>
        <button
          onClick={() => navigate('/order-management')}
          className='tw-text-[12px] tw-text-gray-400'
        >
          ← Order management
        </button>
        <h2 className='font-heading tw-text-2xl'>SEO</h2>
      </div>

      <Formik
        initialValues={toInitialValues(seo)}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form className='tw-flex tw-flex-col tw-gap-4 tw-max-w-2xl'>
            <div className='tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-bg-white tw-p-4 tw-flex tw-flex-col tw-gap-4'>
              <CDInput name='metaTitle' label='Meta title' />
              <TextArea name='metaDescription' label='Meta description' />
              <CDInput name='keywords' label='Keywords (comma separated)' />
              <CDImage name='ogImage' label='OG image' />
              <label className='tw-flex tw-items-center tw-gap-2 tw-text-sm tw-cursor-pointer'>
                <input
                  type='checkbox'
                  checked={!!formik.values.sitemapEnabled}
                  onChange={(e) =>
                    formik.setFieldValue('sitemapEnabled', e.target.checked)
                  }
                  className='tw-w-4 tw-h-4 tw-cursor-pointer'
                />
                Enable sitemap
              </label>
            </div>

            <div>
              <CDButton
                type='submit'
                processing={formik.isSubmitting}
                label='Save SEO settings'
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default Seo
